import { getRequestTransportErrorMessage } from '#/utils/requestError';

const CODE_MESSAGES = {
  SERIAL_NUMBER_WHITESPACE_NOT_ALLOWED: '序號不可含前後空白',
  INSPECTION_REPORT_REQUIRED_ITEM_MISSING: '必填檢測項目未填完整',
  WORK_ORDER_SERIAL_OUT_OF_RANGE: '序號不在工單配置範圍內',
  MATERIAL_SN_IDENTITY_IMMUTABLE: '此序號已有登錄，請改走重測',
  MATERIAL_SN_DOWNSTREAM_REFERENCE_EXISTS: '序號已被售後引用，無法作廢',
  RESOURCE_VERSION_CONFLICT: '資料已被他人修改，請重新載入後再試',
};

export function getInspectionReportApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }
  const data = error?.response?.data;
  const code = data?.code;
  if (code && CODE_MESSAGES[code]) {
    return data?.message || CODE_MESSAGES[code];
  }
  if (typeof data?.message === 'string' && data.message.trim()) {
    return data.message;
  }
  return fallback;
}

export const INSPECTION_STATUS_LABELS = {
  PASS: '合格',
  FAIL: '不合格',
  INCOMPLETE: '未完成',
  INVALID: '無有效登錄',
};
